import notification from '../helpers/notification'
import axios from 'axios'

const $ = kendo.jQuery

$.ajaxSetup({
  error: function (xhr) {
    const [contentType] = (xhr.getResponseHeader('Content-Type') || '').split(';')[0]
    const statusCode = xhr.status
    const responseText =
      contentType == 'application/json'
        ? JSON.parse(xhr.responseText || '{}')
        : contentType == 'text/html'
        ? xhr.responseText.substring(
            xhr.responseText.indexOf('<body bgcolor="white">') + 22,
            xhr.responseText.indexOf('</body>'),
          )
        : xhr.responseText
    if (statusCode == 500) {
      notification(responseText, 'exception')
    }
  },
})

$(document).ajaxComplete(function (e, xhr, options) {
  const [contentType] = (xhr.getResponseHeader('Content-Type') || '').split(';')

  if (xhr.status === 403) {
    notification(`You don't have permissions`, 'error')
  }

  if (xhr.status !== 500 && contentType == 'application/json') {
    var message = '',
      response = {}
    try {
      response = JSON.parse(xhr.responseText || '{}')
      // eslint-disable-next-line no-empty
    } catch (err) {}

    if (response.errors) {
      for (var prop in response.errors) {
        message += response.errors[prop].errors.join(',')
      }

      notification(message, 'error')

      $('.k-grid').one('dataBinding', function (e) {
        e.preventDefault()
      })
    } else {
      showNotification(options.type)
    }
  }
})

const showNotification = (verb) => {
  verb = verb.toUpperCase()
  if (verb == 'POST') {
    notification('Record created successfully', 'success')
  } else if (verb == 'PUT') {
    notification('Record updated successfully', 'success')
  } else if (verb == 'DELETE') {
    notification('Record deleted successfully', 'success')
  }
}

const errorResponseHandler = (error) => {
  if (!error.message.endsWith('401')) {
    notification('There was an error ' + error.message, 'error')
  }
  return Promise.reject(error.response)
}

const urlsWithNoNotification = [
  '/api/Token',
  '/api/Token/refreshToken',
  '/api/VersionInfo/reportBug',
  '/api/process/ProcessManager/run',
  '/api/List/FxRate/sendContractTicket',
  '/api/heroux/ffecReconciliationReport/updateArTransferAmount',
  '/api/config/Client/CopyClientConfig',
  '/api/list/FxRate/importFxRates',
  '/api/list/DivisionForecast/importCashFlow',
  '/api/report/ExposureReport/sendUndeliveredReport',
  '/api/report/ExposureReport/sendExpiryOptionReport',
  '/api/report/ExposureReport/sendExposureChart',
  '/api/report/ExposureReport/sendUndeliveredMail',
  '/api/report/BidRate/saveScenarioBidRate',
  '/api/report/BidRate/deleteScenarioBidRate',
  '/api/report/BidRate/sendBidRatePricerReport',
  '/api/heroux/Rate/importVolatility',
  '/api/report/ExposureReport/Verify',
  '/api/report/ExposureReport/SaveSendingList',
  '/api/report/ExposureReport/SendReadyToSendEmails',
  '/api/report/ExposureReport/AddUndeliveredBalanceSendingList',
  '/api/report/ExposureReport/UpdateUndeliveredBalanceSendingList',
  '/api/report/ExposureReport/getUndeliveredMail',
  '/api/report/ExposureReport/saveUndeliveredMail',
  '/api/config/sendingMessage/setUndeliveredSendingMessage',
  '/api/report/MonthlyReportSendingList/SendBonCoupMail',
  '/api/report/MonthlyReportSendingList/CreateNewList',
  '/api/report/monthlyReportSendingList/GetBonCoupMail',
  '/api/report/monthlyReportSendingList/executeProcess',
  '/api/report/monthlyReportSendingList/validateAll',
  '/api/report/SendingMessage/updateSequence',
  '/api/report/DrawDown/GetEmailPreview',
  '/api/config/FlowType/updateHedgeStrategy',
]

const onFullfilled = (response) => {
  if (response == null) return
  let message = ''
  if (response.data.Error) {
    for (let prop in response.data.Error.errors) {
      message += response.data.Error.errors[prop].errorMessage + '<br>'
    }
    notification(message, 'error')

    return response
  }
  if (response.data.errors) {
    for (let prop in response.data.errors) {
      message += response.data.errors[prop].errors.join(', ')
    }
    notification(message, 'error')

    return response
  }
  const {
    config: {url, method},
  } = response

  if (!urlsWithNoNotification.includes(url.split('?')[0])) showNotification(method)
  return response
}

axios.interceptors.response.use(onFullfilled, errorResponseHandler)
